// extracted by mini-css-extract-plugin
export var deliveryRow = "_kh-a";
export var fixedHeight = "_kh-4";
export var freightLogo = "_kh-9";
export var fullWidth = "_kh-3";
export var priceColumn = "_kh-5";
export var radioSelected = "_kh-7";
export var radioUnselected = "_kh-6";
export var selectedOption = "_kh-2";
export var selectedOptionContainer = "_kh-1";
export var selection = "_kh-0";
export var tallSkeletonText = "_kh-8";